import { IntlShape } from "react-intl";

const NOTIFICATION_OPTIONS = (intl: IntlShape) => [
  {
    value: "team",
    label: intl.formatMessage({
      id: "settings.notifications.teamMessages",
      defaultMessage: "Team messages",
    }),
  },
  {
    value: "off",
    label: intl.formatMessage({
      id: "settings.notifications.off",
      defaultMessage: "Off",
    }),
  },
  {
    value: "custom",
    label: intl.formatMessage({
      id: "settings.notifications.customSettings",
      defaultMessage: "Custom settings",
    }),
  },
];

export default NOTIFICATION_OPTIONS;
